import cx from 'classnames';

import { Paragraph } from './Paragraph';
import styles from './Paragraph.css';

const ParagraphPlugin = ({ className, PARAGRAPH_TAG, ...attributes } = {}) => ({
  renderElement: Paragraph({
    className: cx(styles.paragraph, className),
    PARAGRAPH_TAG,
    ...attributes,
  }),
});

export { ParagraphPlugin };
